<script lang="ts">
  export let followUpList: object;
</script>

<input class="fs-exclude" name="followUpList" type="hidden" value={followUpList ? JSON.stringify(followUpList) : ''} />
